import { render, staticRenderFns } from "./EventMarketing.vue?vue&type=template&id=9716b992"
import script from "./EventMarketing.vue?vue&type=script&lang=js"
export * from "./EventMarketing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports